import { Avatar } from "@fluentui/react-components";
import PropTypes from "prop-types";
import "./Fluent-Avatar.scss";

export const FluentAvatar = (props) => (
  <Avatar {...props} data-testid="fluent-avatar" />
);

FluentAvatar.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
};
